/** @jsxImportSource @emotion/react */
import isMobile from 'ismobilejs';
import type { Chat } from '@trinity/chat';
import { useAvatarPanel } from '@trinity/chat-components/components/DigitalTwin/AvatarPanel.context';
import { SystemAuthor } from './Message.Author';
import { ChatMessageVariantSelector } from './Message.VariantSelector';
import { useStyles } from './Message.System.styles';

type Props = {
  className?: string;
  item: Chat.Query;
};

export const SystemUserCancelledMessage = ({ className, item }: Props) => {
  const device = isMobile();
  const styles = useStyles();
  const { showAuthor } = useAvatarPanel();

  return (
    <div css={styles.root} className={className}>
      {showAuthor && !device.phone && (
        <div css={styles.authorWrap}>
          <SystemAuthor css={styles.author} />
          <ChatMessageVariantSelector item={item} />
        </div>
      )}
      <div>
        <div css={[styles.body, { fontStyle: 'italic' }]}>
          Message cancelled by user.
        </div>
      </div>
    </div>
  );
};